module.exports = __webpack_public_path__ + "static/Gilroy-ExtraBold-cc9a206f686bb0771a6653567381f5ac.woff2";